import type { TBudgetStatus } from '#interfaces/budgetStatus'
import { PRODUCT_STATUSES, type TProductStatus } from '#interfaces/productStatus'
import {
  getPropositionStatusLabel,
  PROPOSITION_STATUS_VARIANT_MAP,
  PROPOSITION_STATUSES,
  type TPropositionStatus,
} from '#interfaces/propositionStatus'
import type { ISubscriptionSummary } from '#interfaces/subscription'

export { PRODUCT_STATUSES, type TProductStatus }
export { getPropositionStatusLabel, PROPOSITION_STATUSES, type TPropositionStatus }
export { PROPOSITION_STATUS_VARIANT_MAP as STATUS_VARIANT_MAP }

export const PERSONAL_CARD_STATUS_FILTERS = [
  'ordered',
  'in_production',
  'active',
  'blocked',
  'terminating',
  'terminated',
  'needs_attention',
] as const
export type TPersonalCardStatusFilter = (typeof PERSONAL_CARD_STATUS_FILTERS)[number]

/** "with_budget" means a budget that has not ended, as GET /propositions?hasBudget=true counts it */
export const PERSONAL_CARD_BUDGET_FILTERS = ['with_budget', 'without_budget'] as const
export type TPersonalCardBudgetFilter = (typeof PERSONAL_CARD_BUDGET_FILTERS)[number]

export interface IPersonalCard {
  id: string
  propositionId: string
  status: string
  statusLabel: string
  /** Human-readable card status from Mobidesk (proposition-level); preferred for display */
  statusDescription?: string | null
  propositionStatus: TPropositionStatus
  product: {
    id: string
    name: string
    type: string
    status: TProductStatus
    engravedId: string | null
    statusDescription: string | null
  } | null
  assignedTo: {
    id: string
    displayName: string | null
    firstName?: string | null
    lastNamePrefix?: string | null
    lastName?: string | null
  } | null
  assignedTill: string | null
  budgetPeriodType: string | null
  /**
   * currentBudget, cardBalance, collectedBalance, pendingBalance, onNalBalance
   * and budgetAmount are euros, converted from the backend's integer cents by
   * the fetch hooks.
   */
  currentBudget: number | null
  cardBalance: number | null
  collectedBalance: number | null
  pendingBalance: number | null
  onNalBalance: number | null
  budgetAmount: number
  nextReloadDate: string | null
  /** Mapped from budget.status. Unknown values are null. */
  budgetStatus: TBudgetStatus | null
  currency: string
  companyId?: string
  companyName?: string
  missingRequiredFields: string[]
  isReplacement: boolean
  /** True when the card holds at least one subscription, open or closed. */
  hasSubscription: boolean
  /** Every subscription on the card, newest first. */
  subscriptions: ISubscriptionSummary[]
}
